const formatCallDuration = (value, estimated = false) => {
  const totalSeconds = Math.round(Number(value));
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return '';

  const prefix = estimated ? '~' : '';
  if (totalSeconds < 60) return `${prefix}${totalSeconds} sec`;

  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) return `${prefix}${totalMinutes} min ${seconds} sec`;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${prefix}${hours} hr ${minutes} min ${seconds} sec`;
};

export default formatCallDuration;
